export const STAFF_PAGE_ACTIONS = {
  FETCH_ONE_STAFF: 'STAFF_PAGE_ACTIONS/FETCH_ONE_STAFF',
  SET_ONE_STAFF: 'STAFF_PAGE_ACTIONS/SET_ONE_STAFF',
  SET_STAFF_PAGE_BUSINESS_UNITS: 'STAFF_PAGE_ACTIONS/SET_STAFF_PAGE_BUSINESS_UNITS',
  SET_LOADING_STATUS: 'STAFF_PAGE_ACTIONS/SET_LOADING_STATUS',
  SHOW_ERROR: 'STAFF_PAGE_ACTIONS/SHOW_ERROR',
  CHANGE_STAFF_STATUS: 'STAFF_PAGE_ACTIONS/CHANGE_STAFF_STATUS',
  CHANGE_STAFF_BUSINESS_UNITS: 'STAFF_PAGE_ACTIONS/CHANGE_STAFF_BUSINESS_UNITS',
  SHOW_TOAST: 'STAFF_PAGE_ACTIONS/SHOW_TOAST',
  RESET_STAFF_PASSWORD: 'STAFF_PAGE_ACTIONS/RESET_STAFF_PASSWORD',
  UPDATE_STAFF_MFA: 'STAFF_PAGE_ACTIONS/UPDATE_STAFF_MFA',
  UPDATE_STAFF_PHONE: 'STAFF_PAGE_ACTIONS/UPDATE_STAFF_PHONE',
  UPDATE_STAFF_NAME: 'STAFF_PAGE_ACTIONS/UPDATE_STAFF_NAME',
  SET_PHONE_UPDATE_LOADING: 'STAFF_PAGE_ACTIONS/SET_PHONE_UPDATE_LOADING',
  FINISH_PHONE_UPDATE: 'STAFF_PAGE_ACTIONS/FINISH_PHONE_UPDATE',
  CHANGE_MENTOR_ENABLE_TIME_TRACKING: 'STAFF_PAGE_ACTIONS/CHANGE_MENTOR_ENABLE_TIME_TRACKING',
  CHANGE_USER_EXPERIMENTAL_FEATURES: 'STAFF_PAGE_ACTIONS/CHANGE_USER_EXPERIMENTAL_FEATURES',
};

export const putStaffPageLoadingStatus = (status) => ({
  type: STAFF_PAGE_ACTIONS.SET_LOADING_STATUS,
  payload: status,
});

export const showStaffPageError = () => ({
  type: STAFF_PAGE_ACTIONS.SHOW_ERROR,
});

export const fetchStaffPage = (id) => ({
  type: STAFF_PAGE_ACTIONS.FETCH_ONE_STAFF,
  payload: id,
});

export const putStaffPage = (staff) => ({
  type: STAFF_PAGE_ACTIONS.SET_ONE_STAFF,
  payload: staff,
});

export const putStaffPageBusinessUnits = (businessUnits) => ({
  type: STAFF_PAGE_ACTIONS.SET_STAFF_PAGE_BUSINESS_UNITS,
  payload: businessUnits,
});

export const showToast = (toastType) => ({
  type: STAFF_PAGE_ACTIONS.SHOW_TOAST,
  payload: toastType,
});

export const changeUserStatus = (status, userId) => ({
  type: STAFF_PAGE_ACTIONS.CHANGE_STAFF_STATUS,
  payload: { status, userId },
});

export const changeStaffBusinessUnits = (businessUnits, userId) => ({
  type: STAFF_PAGE_ACTIONS.CHANGE_STAFF_BUSINESS_UNITS,
  payload: { businessUnits, userId },
});

export const resetStaffUserPassword = (userId) => ({
  type: STAFF_PAGE_ACTIONS.RESET_STAFF_PASSWORD,
  payload: { userId },
});

export const updateStaffUserMfa = (userId, method) => ({
  type: STAFF_PAGE_ACTIONS.UPDATE_STAFF_MFA,
  payload: { userId, method },
});

export const updateStaffUserPhone = (userId, phoneNumber) => ({
  type: STAFF_PAGE_ACTIONS.UPDATE_STAFF_PHONE,
  payload: { userId, phoneNumber },
});

export const updateStaffUserName = (userId, firstName, lastName) => ({
  type: STAFF_PAGE_ACTIONS.UPDATE_STAFF_NAME,
  payload: { userId, firstName, lastName },
});

export const setPhoneUpdateLoading = (status) => ({
  type: STAFF_PAGE_ACTIONS.SET_PHONE_UPDATE_LOADING,
  payload: status,
});

export const finishPhoneUpdate = (phone) => ({
  type: STAFF_PAGE_ACTIONS.FINISH_PHONE_UPDATE,
  payload: phone,
});

export const changeMentorEnableTimeTracking = (enableTimeTracking, userId) => ({
  type: STAFF_PAGE_ACTIONS.CHANGE_MENTOR_ENABLE_TIME_TRACKING,
  payload: { enableTimeTracking, userId },
});

export const changeUserExperimentalFeatures = (experimentalFeatures, userId) => ({
  type: STAFF_PAGE_ACTIONS.CHANGE_USER_EXPERIMENTAL_FEATURES,
  payload: { experimentalFeatures, userId },
});
